import Hamburger from "./Hamburger";
import Navigation from "./Navigation";
import { Link } from "react-router-dom";
import AuthButton from "../auth/AuthButton";
import ITSFINAL_ICON_LOGO from "../../assets/ITSFINAL_ICON_LOGO.png";

export default function Header() {
    return (
        <header className="shrink-0 sticky inset-0 z-50 lg:border-b-[1px] border-dark-border">
            <div className="w-full h-14 lg:h-16 bg-dark-three lg:bg-dark-one flex justify-between items-center px-6">
                <div className="flex items-center gap-4 lg:w-1/6">
                    <Link to="/"><img className="w-7 lg:w-8" src={ITSFINAL_ICON_LOGO} alt="itsfinal logo icon"/></Link>
                    <h1 className="border-dark-border border-l-[1px] pl-4 text-white-main">itsfinal</h1>
                </div>
                <div className="hidden lg:block">
                    <Navigation/>
                </div>
                <div className="lg:w-1/6 lg:flex justify-end items-center hidden">
                    <AuthButton/>
                </div>
                <div className="lg:hidden">
                    <Hamburger/>
                    <Navigation/>
                </div>
            </div>
        </header>
    )
}